import {
    AnalyticsEventPayload,
    LandingEventPayload,
} from "@swiggy-private/analytics/dist/interfaces";

export interface IAnalyticsContext {
    clickEvent: (payload: AnalyticsEventPayload) => void;
    impressionEvent: (payload: AnalyticsEventPayload) => void;
    screenViewEvent: (payload: AnalyticsEventPayload) => void;
    landingSourceEvent: (payload: LandingEventPayload) => void;
}

export enum ScreenNames {
    HOME = "DO-QR-Menu-Home",
    MENU = "DO-QR-Menu-Page",
    CART = "DO-QR-Cart-Page",
    ORDERS = "DO-QR-Orders-Page",
    SEARCH = "DO-QR-Menu-Presearch",
    COLLECTION = "DO-QR-Collection-Page",
    TRACK = "DO-QR-Track-Page",
    BILL_SUMMARY = "DO-QR-Bill-Summary-Page",
    PAYMENT = "DO-QR-Payment-Page",
}

export enum ObjectNames {
    HOME = "QR-Menu-HomePage",
    IMPRESSION_MENU_PILLS = "impression-stacked-widgets",
    IMPRESSION_MENU_PILL = "impression-stacked-widgets-tab",
    CLICK_MENU_PILL = "click-stacked-widgets-tab",
    IMPRESSION_ITEM_CATEGORY = "impression-stacked-widgets-item",
    CLICK_ITEM_CATEGORY = "click-stacked-widgets-item",
    IMPRESSION_GENERATE_BILL_POPUP = "impression-generate-bill-popup",
    CLICK_GENERATE_BILL_POPUP = "click-generate-bill-popup",
    IMPRESSION_BILL_SUMMARY_PENDING = "impression-bill-summary-pending",
    IMPRESSION_BILL_SUMMARY_ERROR = "impression-bill-summary-error",
    IMPRESSION_BILL_SUMMARY_SUCCESS = "impression-bill-summary-success",
    CLICK_BILL_SUMMARY_ERROR_RETRY = "click-bill-summary-error-retry",
    IMPRESSION_POPUP_WIDGET = "impression-popup-widget",
    IMPRESSION_PAYMENT = "impression-payment-page",
    CLICK_PAYMENT_CARD_SWIGGY = "pay-via-swiggy-cta-click",
    CLICK_PAYMENT_CARD_RAZORPAY = "pay-to-rx-cta-click",
    IMPRESSION_PAYMENT_FAILURE = "payment-failure-halfcard-impression",
    CLICK_PAYMENT_FAILURE_CLOSE = "halfcard-close-cta-click",
    CLICK_PAYMENT_FAILURE_TRY_OTHER_METHODS = "payment-failure-cta-click",
    CLICK_PLACE_ORDER = "click-place-order",
    IMPRESSION_CART_PAGE = "impression-cart-page",
    CLICK_CART_ORDERS_TAB_TOGGLE = "cart-tab-toggle",
    IMPRESSION_BILL_PAYMENT = "impression-pay-bill-halfcard",
    CLICK_BILL_PAYMENT_CTA = "click-pay-bill-halfcard",
    CLICK_PAY_ONLINE_CTA = "pay-online-cta-click",
    IMPRESSION_PAY_ONLINE_CTA = "pay-online-cta-impression",
    CLICK_PAY_SERVER_CTA = "pay-server-cta-click",
    IMPRESSION_PAY_SERVER_CTA = "pay-server-cta-impression",
}

export enum ObjectValues {
    HOME = "QR-Menu-HomePage",
    CURTAIN_SWIPE_UP = "View-Menu-Swipe",
    IMPRESSION_MENU_PILLS = '{"property_type":"Native_QR_Menu_StackedWidget"}',
}

export interface IEventPayload {
    eventFn: (payload: AnalyticsEventPayload) => void;
    screenName: ScreenNames;
    objectName: string;
    objectValue?: string;
    objectPosition?: string;
    context?: string;
    extraParams?: Record<string, string | number | boolean>;
}
